import {AfterViewInit, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {Label, PaymentInfo, Response, StaticMethods, UploadInfo} from '../../../model/GeneralModels';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {AppSettingsService} from '../../../services/app-settings.service';
import {GeneralService} from '../../../services/general.service';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {tap} from 'rxjs/operators';
import {
  Insurance,
  InsuranceMinimalInfo,
  IntroductionLetterScenario, RecompenseScenario,
  SubsetDetails
} from '../../../model/IntroductionLetterModel';
import {IntroductionLetterService} from '../../../services/introduction-letter.service';
import {IntroductionLetterFormComponent} from '../../../Dialogs/introduction-letter-form/introduction-letter-form.component';
import {RecompenseFormComponent} from '../../../Dialogs/recompense-form/recompense-form.component';

@Component({
  selector: 'app-subset-requests',
  templateUrl: './subset-requests.component.html',
  styleUrls: [
    '../../../assets/Content/src/css/lib.vendor.css',
    '../../../assets/Content/src/css/lib.picker.css',
    '../../../assets/Content/src/css/ini.bime.css',
    '../../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../../assets/css/light.theme.css'
  ]
})
export class SubsetRequestsComponent implements OnInit, AfterViewInit {
  paymentMode = false;
  formGroup: FormGroup;
  myRequestsButton: boolean;
  translation: any = {};
  productName: string;
  insurance: Insurance = new Insurance();
  fileInfo: UploadInfo;


  constructor(
    private service: IntroductionLetterService,
    private router: Router,
    public settings: AppSettingsService,
    private cdRef: ChangeDetectorRef,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    public dialog: MatDialog
  ) {
    this.formGroup = this.fb.group({
      discountCode: ['']
    });
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.productName = params.productName;
      if (StaticMethods.checkState(this.router, ['requestID'], `/${this.productName}/requests`)) {
        this.getDetails(history.state.requestID);
        this.cdRef.detectChanges();
      }
    });
  }

  ngAfterViewInit() {
  }

  addNewSubset() {
    console.log(this.insurance);
    const minifiedInsurance = new InsuranceMinimalInfo(this.insurance);
    this.router.navigate([`/insurance-service/${this.productName}/new-request`], {
      state: {
        insurance: minifiedInsurance
      }
    });
  }

  redirectToUpload(fileLabel: Label, formID: number) {
    this.fileInfo = {
      persianName: fileLabel.getPersianLabel(),
      englishName: fileLabel.getEnglishLabel(),
      id: formID
    };
  }

  hideUpload($event) {
    console.log($event);
  }

  takeAction(subsetID: number) {
    console.log(subsetID);
    let index = this.insurance.subsetList.findIndex(item => {
      return item.getId() === subsetID;
    });
    if (index === -1) {
      index = this.insurance.subsetList.findIndex(item => {
        return item.getFormID() === subsetID;
      });
    }
    console.log(this.insurance.subsetList.findIndex(item => {
      return item.getFormID() === subsetID;
    }));
    console.log(index);
    const subset = this.insurance.subsetList[index];
    console.log(subset.getStep());
    switch (this.productName) {
      case 'INTRODUCTION_LETTER':
        switch (subset.getStep()) {
          case IntroductionLetterScenario.fileUploaded:
            this.redirectToUpload(
              subset.getFileType(this.settings),
              subset.getFormID()
            );
            break;
          case IntroductionLetterScenario.formSubmitted:
            this.fillForms(subset.getId());
            break;
          case IntroductionLetterScenario.testUploaded:
            this.redirectToUpload(
              subset.getFileType(this.settings),
              subset.getFormID()
            );
            break;
          case IntroductionLetterScenario.letterReleased:
            this.download(subset.getFormID());
            break;
          default:
            console.log(subset.getStep());
        }
        break;
      case 'RECOMPENSE':
        switch (subset.getStep()) {
          case RecompenseScenario.fileUploaded:
            this.redirectToUpload(
              subset.getFileType(this.settings),
              subset.getFormID()
            );
            break;
          case RecompenseScenario.formSubmitted:
            this.fillForms(subset.getId());
            break;
          case RecompenseScenario.testUploaded:
            this.redirectToUpload(
              subset.getFileType(this.settings),
              subset.getFormID()
            );
            break;
          case RecompenseScenario.sendingDocument:
            StaticMethods.openDialog(this.dialog, subset.documentsSendMethod, () => {}, '250px');
            break;
          default:
            console.log(subset.getStep());
        }
    }
  }

  // openDialog(subRequestID): void {
  //   const dialogRef = this.dialog.open(HeightWeightComponent, {
  //     width: '250px',
  //     data: {subRequestID}
  //   });
  //
  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result) {
  //       this.getDetails(this.requestDetails.getRequestID());
  //     }
  //   });
  // }

  fillForms(subsetID: number) {
    let dialogRef;
    switch (this.productName) {
      case 'INTRODUCTION_LETTER':
         dialogRef = this.dialog.open(IntroductionLetterFormComponent, {
          width: '350px',
          data: {
            productName: this.insurance.productName,
            subsetID
          }
        });
         break;
      case 'RECOMPENSE':
         dialogRef = this.dialog.open(RecompenseFormComponent, {
          width: '350px',
          data: {
            subsetID
          }
        });
         break;
      default:
        throw new Error('productName not supported: ' + this.productName);
    }
    if (dialogRef) {
      dialogRef.afterClosed().subscribe(dialogResult => {
        if (dialogResult) {
          console.log('closed, product name: ', this.productName);
          this.getDetails(this.insurance.id);
        }
      });
    }
  }

  getDetails(id: number) {
    this.service.getInsuranceInfoById(id, this.productName).pipe(
      tap()
    ).subscribe((response: Response) => {
      if (response.success) {
        console.log(response);
        this.translation = StaticMethods.appendTranslation(response.translation, this.translation);
        this.insurance = new Insurance(this.productName, response.data);
        console.log(this.insurance);
        this.insurance.subsetList.forEach(subset => {
          this.setButton(subset);
        });
      }
    });
  }

  setButton(subset: SubsetDetails) {
    switch (this.productName) {
      case 'INTRODUCTION_LETTER':
        switch (subset.getStep()) {
          case IntroductionLetterScenario.fileUploaded:
            this.myRequestsButton = false;
            console.log('اپلود ' + subset.getFileType(this.settings).getPersianLabel());
            subset.setMainLabel('اپلود عکس ' + subset.getFileType(this.settings).getPersianLabel());
            break;
          case IntroductionLetterScenario.formSubmitted:
            subset.setMainLabel('تکمیل پرسشنامه');
            break;
          case IntroductionLetterScenario.testUploaded:
            const testInfo = subset.getFileType(this.settings);
            subset.setMainLabel('اپلود عکس ' + testInfo.getPersianLabel());
            break;
          case IntroductionLetterScenario.letterReleased:
            subset.setMainLabel('دانلود معرفی نامه');
            break;
        }
        break;
      case 'RECOMPENSE':
        switch (subset.getStep()) {
          case RecompenseScenario.fileUploaded:
            this.myRequestsButton = false;
            subset.setMainLabel('اپلود عکس ' + subset.getFileType(this.settings).getPersianLabel());
            break;
          case RecompenseScenario.formSubmitted:
            subset.setMainLabel('تکمیل پرسشنامه');
            break;
          case RecompenseScenario.testUploaded:
            const testInfo = subset.getFileType(this.settings);
            subset.setMainLabel('اپلود عکس ' + testInfo.getPersianLabel());
            break;
          case RecompenseScenario.sendingDocument:
            subset.setMainLabel('روش ارسال');
            break;
        }
        break;
    }
    if (subset.getFormID()) {
      subset.setSecondaryLabel('درخواست موارد دیگر');
    }
  }

  download(formID: number) {
    this.service.downloadLetter(formID).subscribe((response: Response) => {
      if (response.success) {
        StaticMethods.goToLink(response.data.directLink);
      }
    });
  }

  hideFinance() {
    this.paymentMode = false;
  }

  secondaryClicked(subset: SubsetDetails) {
    StaticMethods.openDialog(this.dialog, 'آیا درخواست معرفی نامه جدید دارید؟', (result) => {
      if (result) {
        this.fillForms(subset.getId());
      }
    }, '250px');
  }

  gotToMyRequests() {
    this.router.navigate(['/INTRODUCTION_LETTER/requests']);
  }
}
